import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-forgot-password-success-popup',
  standalone: false,
  templateUrl: './forgot-password-success-popup.html',
  styleUrl: './forgot-password-success-popup.scss'
})
export class ForgotPasswordSuccessPopup {

  emailId: string;

  constructor(
    private readonly dialogRef: MatDialogRef<ForgotPasswordSuccessPopup>,
    @Inject(MAT_DIALOG_DATA) public data: { emailId: string }
  ) {
    this.emailId = data.emailId;
  }

  close() {
    this.dialogRef.close(false);
  }
}